Namespace 'Generic'

class Generic.AsyncJob
  # Generic ResqueJob invoker, use this instead of creating new AsyncJob or other existing *.AsyncJob

  constructor: ->
    _.extend(@, Backbone.Events)

  start: (jobEndpoint, params) =>
    @job = new ResqueJob
      url: "#{jobEndpoint}"
      data: params
      success: (results) =>
        @trigger('completed', results)
      error: (results) =>
        @trigger('failed', results)
    @job.start()

  stop: ->
    @job.stop()
